import { useRef } from 'react'
import { useDashboardHome } from '../../../hooks/useDashboardHome'
import DashboardFreshness from '../DashboardFreshness'
import { useAuthStore } from '../../../stores/authStore'
import HomeKpis from './HomeKpis'
import InboundChart from './InboundChart'
import NextUpCard from './NextUpCard'
import ReachingYouCard from './ReachingYouCard'
import MentionsCard from './MentionsCard'
import ProjectsCard from './ProjectsCard'
import TeamCard from './TeamCard'
import VoiceNowStrip from './VoiceNowStrip'
import MyTimeCard from './MyTimeCard'

export default function HomeDashboard() {
  const { data, loading, refresh } = useDashboardHome()
  const firstName = useAuthStore((s) => s.user?.firstName) || ''
  const mentionsRef = useRef<HTMLDivElement>(null)
  const dateLabel = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })

  return (
    <div className="flex-1 min-w-0 h-full flex flex-col bg-background text-foreground">
      <div className="h-14 shrink-0 px-6 flex items-center gap-3 border-b border-border bg-card">
        <h1 className="text-sm font-semibold text-foreground">Home</h1>
        <span className="text-xs text-muted-foreground">{dateLabel}{firstName ? ` · Hi, ${firstName}` : ''}</span>
        <div className="ml-auto">
          <DashboardFreshness generatedAt={data?.generatedAt} onRefresh={() => refresh(true)} />
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto">
        <main className="px-8 py-6 space-y-5">
          {loading && !data && (
            <>
              <div className="h-24 rounded-xl bg-card animate-pulse" />
              <div className="h-40 rounded-xl bg-card animate-pulse" />
              <div className="h-64 rounded-xl bg-card animate-pulse" />
            </>
          )}
          {data && (
            <>
              <HomeKpis kpis={data.kpis} onMentionsClick={() => mentionsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })} />
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
                <div className="xl:col-span-2"><InboundChart days={data.inbound} /></div>
                <NextUpCard items={data.nextUp} />
              </div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
                <ReachingYouCard items={data.reachingYou} />
                <MentionsCard ref={mentionsRef} items={data.mentions} digest={data.emotionDigest} />
              </div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
                <div className="xl:col-span-2"><ProjectsCard boards={data.projects} /></div>
                <div className="flex flex-col gap-4">
                  <TeamCard team={data.team} />
                  <MyTimeCard time={data.time} />
                </div>
              </div>
              <VoiceNowStrip channels={data.voiceNow} />
            </>
          )}
        </main>
      </div>
    </div>
  )
}
